import { CheckCircle2, Clock } from "lucide-react";

import { cn } from "@/lib/utils";

import type { MiniWeekPayload } from "./types";

// Sprint 9.3 — Bloc MiniWeek pour Calendar D2.
// Émis par tool get_week_summary ou find_free_slots.

const STATUS_STYLE = {
  free: "bg-fabrik-green-soft border-l-2 border-fabrik-green text-fabrik-accent-text",
  busy: "bg-fabrik-red-soft border-l-2 border-fabrik-red text-fabrik-red",
  tentative:
    "bg-fabrik-orange-soft border-l-2 border-fabrik-orange text-fabrik-orange",
} as const;

export function MiniWeekBlock({ payload }: { payload: MiniWeekPayload }) {
  return (
    <div className="rounded-fabrik-card border border-border bg-card px-4 py-3 shadow-card">
      {payload.title && (
        <p className="text-[13px] font-semibold text-foreground mb-3">
          {payload.title}
        </p>
      )}
      <div
        className={cn(
          "grid gap-2",
          payload.days.length === 5 ? "grid-cols-5" : "grid-cols-7",
        )}
      >
        {payload.days.map((day) => (
          <div key={day.date} className="flex flex-col gap-1">
            <div className="text-[10.5px] uppercase tracking-wider text-fabrik-text-3 text-center pb-1 border-b border-border">
              {day.label}
            </div>
            <div className="flex flex-col gap-0.5">
              {day.slots.map((slot, i) => (
                <div
                  key={i}
                  className={cn(
                    "rounded px-1.5 py-1 text-[10.5px]",
                    STATUS_STYLE[slot.status],
                  )}
                  title={slot.label}
                >
                  <div className="font-medium">{slot.time}</div>
                  {slot.label && (
                    <div className="text-[9.5px] opacity-80 truncate">
                      {slot.label}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {payload.suggested && payload.suggested.length > 0 && (
        <div className="mt-3 pt-3 border-t border-border">
          <p className="text-[10.5px] uppercase tracking-wider text-fabrik-text-3 mb-1.5 flex items-center gap-1">
            <CheckCircle2 className="size-3 text-fabrik-green" />
            Créneaux suggérés
          </p>
          <ul className="flex flex-wrap gap-1.5">
            {payload.suggested.map((s, i) => (
              <li
                key={i}
                className="inline-flex items-center gap-1.5 rounded-fabrik-pill bg-fabrik-green-soft text-fabrik-accent-text px-2.5 py-1 text-[11px]"
              >
                <Clock className="size-3" />
                <span className="font-medium">
                  {s.date} {s.time}
                </span>
                {s.reason && <span className="opacity-80">— {s.reason}</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
